import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {SignatureRequest} from '../shared/models/Signature/SignatureRequest.model';
import {EmbeddedRequestingEvent} from '../shared/models/Signature/EmbeddedRequestingEvent.model';
import {InvestmentReqRes} from '../dashboard/models/investment.model';
import {Observable} from 'rxjs';
import {KeyValuePair} from '../shared/types/KeyValuePair.model';
import {EmbeddedTemplateEvent} from '../shared/models/Signature/EmbeddedTemplateEvent.model';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {

  constructor(private http: HttpService) {
  }

  protected readonly baseEndpoint = 'signature/';
  // gp
  protected readonly createDraftAgreementEndpoint = this.baseEndpoint + 'agreement/draft';
  protected readonly sendAgreementEndpoint = this.baseEndpoint + 'agreement/send';
  protected readonly resendAgreementEndpoint = this.baseEndpoint + 'agreement/resend';


  // templates
  protected readonly templatesAgreementEndpoint = this.baseEndpoint + 'templates';
  // lp
  protected readonly getSignatureRequestEndpoint = this.baseEndpoint + 'agreement/';
  protected readonly signatureRequestSignedEndpoint = this.baseEndpoint + 'agreement/signed/';


  // GP
  public createDraftAgreement(signatureRequest: SignatureRequest): any {
    return this.http.post(this.createDraftAgreementEndpoint, signatureRequest);
  }

  public sendAgreement(eventData: EmbeddedRequestingEvent): Observable<InvestmentReqRes> {
    return this.http.postTyped<InvestmentReqRes>(this.sendAgreementEndpoint, eventData);
  }

  public resendAgreement(investmentId: number): any {
    return this.http.post(this.resendAgreementEndpoint, investmentId);
  }

  public removeAgreement(investmentId: number): any {
    return this.http.delete(this.signatureRequestSignedEndpoint + investmentId.toString());
  }


  // Templates
  public createTemplateDraftAgreement(signatureRequest: SignatureRequest): any {
    return this.http.post(this.templatesAgreementEndpoint, signatureRequest);
  }

  public sendTemplateAgreement(eventData: EmbeddedTemplateEvent): Observable<InvestmentReqRes> {
    return this.http.putTyped<InvestmentReqRes>(this.templatesAgreementEndpoint, eventData);
  }

  public editTemplateAgreement(templateId: string): any {
    const url = `${this.templatesAgreementEndpoint}/${templateId}`;
    return this.http.get(url);
  }

  public getTemplatesAgreement(count: number): Observable<KeyValuePair<string, string>[]> {
    return this.http.getTyped<KeyValuePair<string, string>[]>(this.templatesAgreementEndpoint + `/${count}`);
  }

  public deleteTemplatesAgreement(templateId: string) {
    return this.http.delete(this.templatesAgreementEndpoint + `/${templateId}`);
  }

  // LP / GP
  public getSignatureRequest(investmentId: number, uniqueIdentifier: string, isGp: boolean = false) {
    return this.http.get(`${this.getSignatureRequestEndpoint + investmentId.toString()}/${uniqueIdentifier}/${isGp}`);
  }

  public signatureRequestSigned(investmentId: number, signatureId: string, isGp: boolean = false) {
    return this.http.put(`${this.signatureRequestSignedEndpoint}${investmentId.toString()}/${signatureId}/${isGp}`, {});
  }
}
